import React from 'react';
import '../CSS/Footer.css'; // Import your CSS file for styling
import { FaBullhorn } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="styled-footer">
      <div className="top-footer">
        <div className="footer-title">VIGNAN 2K25</div>

        <div className="footer-nav">
          <a href="#home">Home</a>
          <a href="#events">Events</a>
          <a href="#blog">Blog</a>
          <a href="#contact">Contact</a>
         
        </div>

        <div className="footer-register">
          <a href="https://forms.gle/RH16qNgFAhEcbJ8x5">Register</a>
        </div>
      </div>

      <div className="footer-rights">
        © 2025 Your Brand. All Rights Reserved.
      </div>

      <div className="footer-credit">
        <FaBullhorn className="icon" />
        <span> This website is created by :</span>
        <strong> KARVENTHAN </strong> || Dept: ECE ||
        <span> Mobile: </span>
        <a href="tel:8438126561">8438126561</a>
      </div>
    </footer>
  );
};

export default Footer;
